import {uploadVideoAssetFormUrl, uploadCustomerVideoAssetFormUrl} from "config/paths";

const handleMultipartSubmit = ({
                                   genericFileErrorMessage,
                                   token,
                                   customerId,
                                   setProgress,
                                   redirectTo = null,
                                   isCommonAsset = false,
                                   history = null,
                               }) => ({setFieldError, ...props}) => {
    const requestUrl = isCommonAsset
        ? uploadVideoAssetFormUrl(token)
        : uploadCustomerVideoAssetFormUrl(customerId, token);

    const formData = new FormData();
    formData.append("name", props.codename ? props.codename : props.values?.codename);
    formData.append("description", props.description ? props.description : props.values?.description);
    formData.append("file", props.image ? props.image : props.values?.image);

    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open("POST", requestUrl);
        request.setRequestHeader("Authorization", `Bearer ${token}`);

        request.addEventListener("load", function () {
            setProgress(null);
            const {status, statusText, response} = request;

            if (status >= 200 && status < 300) {
                const data = JSON.parse(response);
                if (redirectTo && data && data.id) {
                    history.push(redirectTo({isCommonAsset, id: data.id, customerId}));
                }
                resolve(data);
            } else {
                console.error(`Error fetching: [${status}] "${statusText}"`);
                reject(genericFileErrorMessage);
            }
        });

        const errorHandler = () => {
            setProgress(false);
            const {status, statusText} = request;
            console.error(`Error fetching: [${status}] "${statusText}"`);
            reject(genericFileErrorMessage);
        };

        request.upload.addEventListener("error", errorHandler);
        request.addEventListener("error", errorHandler);

        request.send(formData);
    });
};

export default handleMultipartSubmit;
